import React from "react";
import CustomModal from "../../../../components/Modal/CustomModal";
import CustomButtonLink from "../../../../components/buttons/CustomButtonLink";
import { SettingsIcon } from "../../../../components/buttons/IconButtons";
import NotInformation from "../../../../components/NotInformation";
import { getPanelEmptyText } from "../Functionality/EventMonitoringCommon";
import ExpandPanelModalApp from "../Functionality/ExpandPanelModalApp";
import EventFeedRow from "../SubComponents/EventFeedRow";
import PanelLoading from "../SubComponents/PanelLoading";

/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    Full Stack
 * @Email       kpozos@ibl.mx
 *
 * Detailed view of a panel with the events it read; scrolling to the bottom reads the next ones.
 */
const ExpandPanelModal = ({ show, panel, feed, onLoadMore, now, display, onHide, onConfigure, canUpdate = false }) => {
    const { t, header, panelEvents, bodyRef, loadMoreIfNeeded, showEmpty, loading } = ExpandPanelModalApp({ panel, feed, onLoadMore });
    const HeaderIcon = header.Icon;

    return (
        <CustomModal
            show={show}
            onHide={onHide}
            display={display}
            size='xl'
            cancelButton={false}
            confirmButton={false}
            topLeftHeader={
                <div className='d-flex align-items-center justify-content-between gap-3 pb-2 pr-5'>
                    <div className='d-flex align-items-center gap-2 minw-0'>
                        <div className={`d-flex flex-shrink-0 align-items-center justify-content-center w-32px h-32px border-radius-4px ${header.pictogram.BACKGROUND_CLASS}`}>
                            <HeaderIcon className={`btn-icon-svg-24px ${header.pictogram.ICON_CLASS}`} />
                        </div>
                        <p className='fs-24px ibl-font-w-600 font-color-text-950 text-ellipsis-1-row'>{header.title}</p>
                    </div>
                    {canUpdate &&
                        <CustomButtonLink
                            id='btn_epm_configure_panel'
                            name='configure_panel'
                            Icon={SettingsIcon}
                            iconProps='btn-icon-svg-12px'
                            splitName={false}
                            className='fs-10px ibl-font-w-500 font-color-general-950 gap-2'
                            onClick={() => onConfigure(panel)}
                        />
                    }
                </div>
            }
            classNameBody='pt-0'
        >
            {showEmpty &&
                <NotInformation
                    text={getPanelEmptyText(panel, t)}
                    card={true}
                />
            }
            {!showEmpty &&
                <div ref={bodyRef} onScroll={loadMoreIfNeeded} className='event-monitoring-expand-body custom-scrollbar'>
                    {panelEvents.length > 0 &&
                        <div className='event-monitoring-feed-list'>
                            {panelEvents.map((event) => (
                                <EventFeedRow key={event.id} event={event} now={now} />
                            ))}
                        </div>
                    }
                    {loading && <PanelLoading className='py-4' />}
                </div>
            }
        </CustomModal>
    );
};

export default ExpandPanelModal;
